// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How the source-message payload value flows through to the target
 * message when a channel modifier fires.
 *
 * PASSTHROUGH: target gets the same value as source. Existing
 * modifiers (`schema_version` 1 or 2) implicitly behave as `PASSTHROUGH`.
 *
 * SPECIFIC: modifier only fires when the source value falls in the
 * half-open range `[value_range_start, value_range_end)`. When it
 * fires, the target receives the source value unchanged. Useful for
 * scoping a modifier to a subset of floors, car indices, or similar
 * enum-like positions.
 *
 * TRANSFORMATIVE: target value = source value + `value_transform_offset`.
 * The offset is signed so negative deltas work — e.g. offset=-1 maps
 * source position 3 to target position 2. Useful when two adapters
 * disagree on indexing (zero- vs one-based floors, opposite-direction
 * stripe layouts, etc.) and a constant offset reconciles them.
 */
export enum ValueTransformMode {
  PASSTHROUGH = 0,
  SPECIFIC = 1,
  TRANSFORMATIVE = 2,
}
